import { POSType } from '../interfaces/POS';

// The only POS types a ticket is sold on (PAUL-3717). Mirrors the backend's PosTypeExtensions.TicketSellingTypes.
export const TICKET_POS_TYPES: POSType[] = [POSType.Physical, POSType.Online];
